<template>
  <div class="dialog-app-form">
    <el-dialog title="添加应用" :visible="visible" @open="onDialogOpen" @close="onDialogClose">
      <el-form label-position="top" ref="appForm" :rules="batchAddRules" :model="appForm">

        <el-form-item
          prop="app_name"
          label="应用名（设备厂商-设备型号-应用类型）">
          <el-input
            v-model="appForm.app_name"
            placeholder="请输入应用名（仅支持英文 + 数字）"
            @keyup.enter.native="onFormSubmit"></el-input>
        </el-form-item>

        <el-form-item label="备注" prop="remarks">
          <el-input
            v-model="appForm.remarks"
            placeholder="请输入备注"
            @keyup.enter.native="onFormSubmit"></el-input>
        </el-form-item>

        <el-form-item label="应用类型" prop="type">
          <el-radio v-model="appForm.type" :label="0">普通版</el-radio>
          <el-radio v-model="appForm.type" :label="1">定制版</el-radio>
        </el-form-item>

        <el-form-item style="display: flex; justify-content: center;">
          <el-button type="danger" @click="onFormSubmit">确定</el-button>
          <el-button @click="onBatchAddCancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'DialogBatchAdd',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      appForm: {
        app_name: '',
        remarks: '',
        type: 0
      },
      batchAddRules: {
        app_name: [
          { required: true, message: '请输入应用名（仅支持英文 + 数字）', trigger: 'change' }
        ],
        remarks: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择升级包类型', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapState('app', [
      'appInfoList'
    ])
  },
  methods: {
    ...mapActions('app', [
      'addAppInfo'
    ]),

    onFileUpload (val) {
      const file = this.$refs['upload'].files[0]

      const filename = file.name.split('.')[0]

      this.appForm.app = file
      this.appForm.version = parseInt(filename.substring(filename.indexOf('_') + 1, filename.length))
    },

    onDialogOpen () {
    },
    onDialogClose () {
      this.$emit('update:visible', false)
    },
    async onFormSubmit () {
      this.$refs['appForm'].validate(async valid => {
        if (valid) {
          try {
            await this.addAppInfo({
              appName: this.appForm.app_name,
              remarks: this.appForm.remarks,
              type: this.appForm.type
            })

            this.$message({
              type: 'success',
              message: '添加成功'
            })

            this.$emit('data-change')
            this.$emit('update:visible', false)
            this.$refs['appForm'].resetFields()
          } catch (err) {
            this.$message({
              type: 'error',
              message: '添加应用失败'
            })
            console.log(err)
          }
        } else {
          return false
        }
      })
    },
    onBatchAddCancel () {
      this.$emit('update:visible', false)
      this.$refs['appForm'].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/base";

.dialog-app-form {
}
</style>



// WEBPACK FOOTER //
// src/components/app/DialogAppForm.vue